const servicesButtons = document.querySelectorAll(
  '.services-list-item-nav-btn .services-btn'
);

const servicesBlocks = document.querySelectorAll('.services-cards');

function activateServicesBlock(button) {
  if (!button) return;

  const targetId = button.dataset.target;
  const targetBlock = document.getElementById(targetId);

  if (!targetBlock) return;

  servicesBlocks.forEach(block => {
    block.classList.remove('active');
    block.hidden = true;
  });

  servicesButtons.forEach(currentButton => {
    currentButton.classList.remove('active');
    currentButton.setAttribute('aria-pressed', 'false');
  });

  targetBlock.hidden = false;

  button.classList.add('active');
  button.setAttribute('aria-pressed', 'true');

  requestAnimationFrame(() => {
    targetBlock.classList.add('active');
  });
}

servicesButtons.forEach(button => {
  button.addEventListener('click', () => {
    activateServicesBlock(button);
  });
});


activateServicesBlock(servicesButtons[0]);